export default "__VITE_ASSET__06946fe8__"